import { createSelector } from 'reselect'

const pollSelector = state => state.poll

const cancelSelector = createSelector(
	[pollSelector],
	poll => ({
		isModified: poll.isModified,
	})
)

export default cancelSelector
